<p (click)="auth?.signOut()">page-not-found works!</p>
